export async function importWrappingKeyFromBytes(rawKeyBytes) {
  const cryptoObj = globalThis?.crypto;

  if (!cryptoObj?.subtle) {
    throw new Error('Web Crypto API is not available');
  }

  return cryptoObj.subtle.importKey(
    'raw',
    rawKeyBytes,
    { name: 'AES-GCM', length: 256 },
    false,
    ['encrypt', 'decrypt']
  );
}
